/**
 * Global Imports
*/

import React from 'react';

/**
 * Root Imports
*/

import { EntryPoint as BaseEntryPoint } from '~/components';

/**
 * Local Imports
*/

import { GuestLayout, VerifiedLayout } from './Layouts';

/**
 * Exports
*/

/**
 * 
 */
export function EntryPoint(props) {
  return (
    <BaseEntryPoint
      guest={ GuestLayout }
      verified={ VerifiedLayout }
    />
  );
}